export enum interestEnum {
  INTEREST_TOTAL = 0,
}
